const BASE_QUESTIONS = [
  {
    q: "What does GCP stand for?",
    opts: [
      "Good Clinical Practice",
      "General Clinical Protocol",
      "Global Compliance Policy",
      "Good Compliance Practice",
    ],
    c: 1,
  },
  {
    q: "Who is primarily responsible for participant safety at the site?",
    opts: ["Investigator", "Sponsor only", "CRO only", "Pharmacy only"],
    c: 1,
  },
  {
    q: "What is informed consent?",
    opts: [
      "Voluntary agreement after understanding risks and benefits",
      "Mandatory enrollment form only",
      "Insurance document",
      "Lab report signature",
    ],
    c: 1,
  },
  {
    q: "Which document describes trial objectives, design, and methods?",
    opts: ["Protocol", "Invoice", "CV", "Monitoring log"],
    c: 1,
  },
  {
    q: "What is source data?",
    opts: [
      "Original records and certified copies of findings",
      "Final CSR tables only",
      "Email threads",
      "Marketing brochure",
    ],
    c: 1,
  },
  {
    q: "Purpose of monitoring visits?",
    opts: [
      "Verify data quality and GCP compliance",
      "Recruit new patients",
      "Approve budgets only",
      "Replace ethics committee",
    ],
    c: 1,
  },
  {
    q: "Who approves the clinical trial protocol ethically?",
    opts: ["Ethics Committee / IRB", "Finance team", "IT department", "HR"],
    c: 1,
  },
  {
    q: "What is a serious adverse event (SAE)?",
    opts: [
      "Results in death, hospitalization, or significant disability",
      "Any mild headache",
      "Missed appointment",
      "Lost sample label",
    ],
    c: 1,
  },
  {
    q: "Essential documents are stored in which file?",
    opts: ["Trial Master File (TMF)", "Personal diary", "Social media", "Travel folder"],
    c: 1,
  },
  {
    q: "Blinding in a trial means:",
    opts: [
      "Participants/staff unaware of treatment assignment",
      "No consent taken",
      "No monitoring done",
      "No protocol followed",
    ],
    c: 1,
  },
  {
    q: "Primary endpoint is:",
    opts: [
      "Main outcome the trial is designed to assess",
      "First visit date",
      "Site address",
      "Monitor name",
    ],
    c: 1,
  },
  {
    q: "Delegation log records:",
    opts: [
      "Tasks delegated to site staff with signatures",
      "Patient birthdays",
      "Travel expenses",
      "Weather notes",
    ],
    c: 1,
  },
  {
    q: "Investigational product accountability includes:",
    opts: [
      "Receipt, storage, dispensing, and return/destruction",
      "Only prescription printing",
      "Only shipping labels",
      "Only patient calls",
    ],
    c: 1,
  },
  {
    q: "Protocol deviation should be:",
    opts: ["Documented and assessed for impact", "Ignored", "Hidden", "Deleted from EDC"],
    c: 1,
  },
  {
    q: "EDC stands for:",
    opts: [
      "Electronic Data Capture",
      "External Document Control",
      "Ethics Decision Committee",
      "Emergency Drug Cabinet",
    ],
    c: 1,
  },
  {
    q: "Randomization helps to:",
    opts: [
      "Reduce selection bias between treatment groups",
      "Increase bias",
      "Skip consent",
      "Avoid blinding",
    ],
    c: 1,
  },
  {
    q: "Sponsor's role includes:",
    opts: [
      "Overall trial management and quality oversight",
      "Only patient care at site",
      "Only lab testing",
      "Only translation",
    ],
    c: 1,
  },
  {
    q: "ALCOA+ principles relate to:",
    opts: [
      "Attributable, Legible, Contemporaneous, Original, Accurate data",
      "Advertising standards",
      "Airline safety",
      "Accounting tax rules",
    ],
    c: 1,
  },
  {
    q: "Screen failure means:",
    opts: [
      "Participant did not meet eligibility criteria",
      "Participant completed study",
      "Monitor left site",
      "Drug expired",
    ],
    c: 1,
  },
  {
    q: "Version control on approved documents ensures:",
    opts: [
      "Staff use current approved content",
      "Older drafts are preferred",
      "Signatures are optional",
      "Audit trail is removed",
    ],
    c: 1,
  },
];

export function buildTemplateSampleRows(count = 100) {
  return Array.from({ length: count }, (_, idx) => {
    const n = idx + 1;
    const base = BASE_QUESTIONS[idx % BASE_QUESTIONS.length];
    const cycle = Math.floor(idx / BASE_QUESTIONS.length) + 1;
    const prefix = cycle > 1 ? `[Set ${cycle}] ` : "";
    return [prefix + base.q, ...base.opts, base.c];
  });
}
